export default __webpack_public_path__ + "static/media/icon-red-check.f8733b1e.svg";